module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.addnewProp.formTitle ? _vm.addnewProp.formTitle : _vm.formTitle,
      "visible": _vm.dialogFormVisible,
      "width": "740px",
      "modal": _vm.modal,
      "before-close": _vm.cancelDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "addnew-from",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, [_vm._l((_vm.formData), function(item) {
    return (item.attr !== 'estimateTime') ? _c('el-form-item', {
      key: item.attr,
      attrs: {
        "label": item.attrName,
        "prop": item.attr,
        "label-width": _vm.formLabelWidth
      }
    }, [(item.attrVisible) ? _c('el-input', {
      attrs: {
        "value": "* * * * * *",
        "disabled": true
      }
    }) : (item.fieldType === 1) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable === 1,
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 2) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable === 1 || _vm.isMoneyEditable(item),
        "placeholder": item.placeholder
      },
      on: {
        "change": function($event) {
          _vm.isShowNextPayAmount(item)
        }
      },
      nativeOn: {
        "keyup": function($event) {
          _vm.onInput(item)
        }
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, [(item.unit) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(item.unit) + "\n          ")]) : _vm._e()], 2) : (item.fieldType === 3 && item.valueArrMap) ? _c('el-select', {
      attrs: {
        "clearable": "",
        "filterable": "",
        "disabled": item.nonEditable === 1,
        "placeholder": item.placeholder
      },
      on: {
        "change": function($event) {
          _vm.selectHandle(item.attr)
        }
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((item.valueArrMap), function(arr) {
      return _c('el-option', {
        key: arr.key,
        attrs: {
          "label": arr.value,
          "value": arr.key
        }
      })
    })) : (item.fieldType === 3 && item.initValue) ? _c('el-select', {
      attrs: {
        "clearable": "",
        "filterable": "",
        "disabled": item.nonEditable === 1,
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((_vm.strToArr(item.initValue)), function(option) {
      return _c('el-option', {
        key: option,
        attrs: {
          "value": option
        }
      })
    })) : (item.fieldType === 4 && _vm.form.type === '3' && _vm.moduleName === 'workReportApi' && item.attr === 'reportDate') ? _c('el-date-picker', {
      attrs: {
        "disabled": _vm.fuction(item),
        "editable": false,
        "type": "month",
        "placeholder": "请选择月份",
        "value-format": "yyyy-MM-dd"
      },
      on: {
        "change": function($event) {
          _vm.datepicker(item)
        }
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 4) ? _c('el-date-picker', {
      attrs: {
        "disabled": _vm.fuction(item),
        "editable": false,
        "type": "date",
        "placeholder": "选择日期",
        "value-format": "yyyy-MM-dd"
      },
      on: {
        "change": function($event) {
          _vm.datepicker(item)
        }
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 5 || item.fieldType === 6) ? [_c('v-upload', {
      attrs: {
        "attrValue": _vm.form[item.attr],
        "defaultList": item.attrValue,
        "type": "image"
      }
    })] : (item.fieldType === 7) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable === 1,
        "type": "textarea",
        "placeholder": item.placeholder,
        "auto-complete": "off"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 8) ? [_c('v-upload', {
      attrs: {
        "attrValue": _vm.form[item.attr],
        "defaultList": item.attrValue,
        "type": "file"
      }
    }), _vm._v(" "), _c('el-checkbox-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      attrs: {
        "value": _vm.form[item.attr]
      }
    }, _vm._l((_vm.form[item.attr]), function(file, index) {
      return _c('el-checkbox', {
        key: file.attachIndex + index,
        attrs: {
          "label": file.filename
        }
      })
    }))] : (item.fieldType === 9) ? _c('el-checkbox-group', {
      attrs: {
        "disabled": item.nonEditable === 1
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((_vm.strToArr(item.initValue)), function(option, index) {
      return _c('el-checkbox', {
        key: index,
        attrs: {
          "label": option,
          "name": item.attr
        }
      })
    })) : (item.attr === 'ifRemind') ? _c('el-switch', {
      on: {
        "change": _vm.remindChange
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 10) ? [_c('el-rate', {
      staticStyle: {
        "padding-top": "7px"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      attrs: {
        "value": _vm.form[item.attr]
      }
    })] : (item.fieldType === 37) ? [_c('birthday', {
      attrs: {
        "item": item,
        "form": _vm.form
      }
    })] : _c(_vm.moduleName, {
      ref: _vm.moduleName,
      refInFor: true,
      tag: "component",
      attrs: {
        "item": item,
        "form": _vm.form,
        "detailId": _vm.addnewProp.id,
        "isNameCheck": _vm.isNameCheck,
        "isCheckRepeat": _vm.isCheckRepeat,
        "listData": _vm.checkListData,
        "child": _vm.routeChild
      },
      on: {
        "showProduct": _vm.productShow,
        "addNew": _vm.addNew,
        "change": _vm.handleFieldEmit,
        "communicatePlan": _vm.communicatePlan,
        "getVisitPlanList": _vm.getVisitPlanList,
        "refundProTotalMoney": _vm.refundProTotalMoney
      }
    })], 2) : _vm._e()
  }), _vm._v(" "), (_vm.nextPayAmount) ? [_c('el-form-item', {
    attrs: {
      "label": "下次预计回款时间",
      "prop": "estimateTime",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.estimateTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "estimateTime", $$v)
      },
      expression: "form.estimateTime"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.nextRemind) ? [_c('el-form-item', {
    attrs: {
      "label": "下次跟进时间",
      "prop": "followTime",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "picker-options": _vm.disableBefore,
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.followTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "followTime", $$v)
      },
      expression: "form.followTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提醒",
      "prop": "notifyType",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.notifyType),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifyType", $$v)
      },
      expression: "form.notifyType"
    }
  }, _vm._l((_vm.notifyType), function(item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.form.notifyType === 5) ? _c('el-form-item', {
    attrs: {
      "label": "提醒时间",
      "prop": "notifyTime",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "picker-options": _vm.disableBefore,
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.notifyTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifyTime", $$v)
      },
      expression: "form.notifyTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "label-width": _vm.formLabelWidth,
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "加入访客",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.plan),
      callback: function($$v) {
        _vm.$set(_vm.form, "plan", $$v)
      },
      expression: "form.plan"
    }
  }, [_vm._v("将此次提醒加入访客计划")])], 1)] : _vm._e(), _vm._v(" "), (_vm.saleStage) ? _c('div', {
    staticClass: "v-warning"
  }, [_vm._v("您开启了一个没有字段的阶段反馈！")]) : _vm._e()], 2), _vm._v(" "), (_vm.moduleName === 'invoice' && _vm.form.customerName && _vm.form.customerName.id) ? _c('add-invoice', {
    ref: "addInvoice",
    attrs: {
      "id": _vm.addnewProp.id,
      "customerId": _vm.form.customerName,
      "invoice": _vm.invoice,
      "express": _vm.express
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleName === 'paymentSheetApi' && _vm.addnewProp.isRed) ? _c('add-payment', {
    attrs: {
      "addnewProp": _vm.addnewProp,
      "id": _vm.addnewProp.refId,
      "checkedInvoices": _vm.checkedInvoices,
      "checkedPaymentSheets": _vm.checkedPaymentSheets,
      "form": _vm.form
    },
    on: {
      "updateTotalMoney": _vm.updateRefundAmount
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleName === 'refund') ? _c('add-refund', {
    attrs: {
      "checkedInvoices": _vm.checkedInvoices,
      "checkedPaymentSheets": _vm.checkedPaymentSheets,
      "form": _vm.form
    },
    on: {
      "updateTotalMoney": _vm.updateRefundAmount
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isApproval) ? _c('p', {
    staticClass: "tips",
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "padding-top": "10px",
      "color": "#ff7c35",
      "font-size": "12px"
    }
  }, [_vm._v("\n        " + _vm._s(("*已开启" + (_vm.moduleMap[_vm.moduleName]) + "审批，新增" + (_vm.moduleMap[_vm.moduleName]) + "进入待审批中，且暂不在" + (_vm.moduleMap[_vm.moduleName]) + "列表中显示。")) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.isApproval ? '提交审批' : _vm.addnewProp.relation === 'contactApi' ? '确认' : '提 交'))])], 1)], 1), _vm._v(" "), (_vm.productCAOshow) ? [(_vm.productType === 'add') ? _c('select-product', {
    staticClass: "add-btn",
    attrs: {
      "moduleName": _vm.moduleName,
      "form": _vm.form,
      "modal": _vm.modal,
      "showClassify": true,
      "productType": _vm.productType,
      "selectIdArr": _vm.selectIdArr,
      "instockproduct": (_vm.form.products && _vm.form.products.productList) || _vm.form.products || _vm.form.productList
    },
    on: {
      "showProduct": _vm.productShow,
      "getProductList": _vm.getProductList,
      "closeSelectPro": function($event) {
        _vm.productCAOshow = false
      }
    }
  }) : (_vm.productType === 'edit') ? _c('products', {
    ref: "products",
    attrs: {
      "moduleName": _vm.moduleName,
      "modal": _vm.modal,
      "surchargeList": _vm.form.products.surchargeList,
      "productList": (_vm.form.products && _vm.form.products.productList) || _vm.form.products || _vm.form.productList,
      "selectProducts": _vm.secondProductList,
      "decimalPrecisionMap": _vm.decimalPrecisionMap
    },
    on: {
      "selectId": _vm.selectId,
      "showProduct": _vm.productShow,
      "emitProductsData": _vm.getCAOProductsData,
      "close": function($event) {
        _vm.productCAOshow = false
      },
      "closeForDetail": function($event) {
        _vm.productsDialog = false
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.modal && _vm.showModal) ? _c('div', {
    staticClass: "v-modal"
  }) : _vm._e(), _vm._v(" "), (_vm.addnewShow) ? _c('add-new', {
    ref: "addNew",
    attrs: {
      "curTemplate": _vm.curTemplate,
      "addnewProp": _vm.addnewPropCopy,
      "modal": _vm.modal
    },
    on: {
      "closeDialog": function($event) {
        _vm.addnewShow = false
      },
      "refresh": _vm.refresh
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7c8969","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/add-new.vue
// module id = 1270
// module chunks = 82